export default "__VITE_ASSET__CJxd_Ki3__";